module.exports = __webpack_public_path__ + "static/media/Malawi.374c343d.png";